import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TextReveal = ({ children, className = '', delay = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Split text into words
    const text = el.textContent;
    const words = text.split(' ');
    el.innerHTML = words
      .map((word) => `<span class="inline-block overflow-hidden" style="padding:0 2px"><span class="inline-block gsap-word" style="transform: translateY(100%); opacity: 0">${word}</span></span>`)
      .join(' ');

    const wordEls = el.querySelectorAll('.gsap-word');

    gsap.to(wordEls, {
      y: 0,
      opacity: 1,
      duration: 0.8,
      stagger: 0.05,
      ease: 'power3.out',
      delay,
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        once: true,
      },
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, [children, delay]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default TextReveal;
